export const Functions = {
  create: true,
  delete: true,
  detail: true,
  search: false
};
export const PageName = '专属卡阶段配置';